export const numberToWords = (num) => {
    if (num === null || num === undefined) return '';
    if (num === 0) return 'Zero Rupees Only';

    const single = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const double = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const formatTrio = (n) => {
        let res = '';
        if (n > 99) {
            res += single[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }
        if (n > 19) {
            res += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        }
        if (n > 9) {
            res += double[n - 10] + ' ';
        } else if (n > 0) {
            res += single[n] + ' ';
        }
        return res;
    };

    let result = '';
    let integerPart = Math.floor(num);
    let fractionalPart = Math.round((num - integerPart) * 100);

    let tempInt = integerPart;
    if (tempInt >= 10000000) {
        result += formatTrio(Math.floor(tempInt / 10000000)) + 'Crore ';
        tempInt %= 10000000;
    }
    if (tempInt >= 100000) {
        result += formatTrio(Math.floor(tempInt / 100000)) + 'Lakh ';
        tempInt %= 100000;
    }
    if (tempInt >= 1000) {
        result += formatTrio(Math.floor(tempInt / 1000)) + 'Thousand ';
        tempInt %= 1000;
    }
    result += formatTrio(tempInt);

    if (result.trim() === '' && integerPart === 0) {
        result = 'Zero';
    }

    result = result.trim() + (integerPart === 1 ? ' Rupee' : ' Rupees');

    if (fractionalPart > 0) {
        result += ' and ' + formatTrio(fractionalPart).trim() + (fractionalPart === 1 ? ' Paisa' : ' Paise');
    }

    return result + ' Only';
};
